import { Fragment, RefObject } from "react";
import { useTranslation } from "react-i18next";

import * as S from "../styles";
import { IVideoTutorial } from "~/types/video";
import Separator from "~/components/ui/Separator";
import ThumbnailPNG from "~/assets/png/thumbnail.png";

type Props = {
  tutorials: IVideoTutorial[];
  selectedIndex: number;
  onSelect: (index: number) => void;
  listRef?: RefObject<HTMLDivElement>;
  height?: number | null;
};

const VideoList = ({
  tutorials,
  selectedIndex,
  onSelect,
  listRef,
  height,
}: Props) => {
  const { t } = useTranslation();

  return (
    <S.TutorialListContent
      ref={listRef}
      style={height ? { height } : undefined}>
      <S.TutorialList>
        {tutorials.map((tutorial, index) => (
          <Fragment key={index}>
            <S.TutorialItem
              active={index === selectedIndex}
              onClick={() => onSelect(index)}>
              <S.TutorialText>
                <img src={ThumbnailPNG} alt="Video icon" />
                {t(tutorial.title)}
              </S.TutorialText>
              <S.TutorialDuration>{tutorial.duration}</S.TutorialDuration>
            </S.TutorialItem>
            {index < tutorials.length - 1 && <Separator type="horizontal" />}
          </Fragment>
        ))}
      </S.TutorialList>
    </S.TutorialListContent>
  );
};

export default VideoList;
